import clsx from "clsx"

import styles from "./SelectListHeaderChipGroup.module.scss"
import { SelectListHeaderChipGroupProps } from "./SelectListHeaderChipGroup.types"

export default function SelectListHeaderChipGroup(props: SelectListHeaderChipGroupProps) {
    const { children, className } = props

    return <div className={clsx(styles.base, className)}>{children}</div>
}
